import { useEffect, useRef, useState, useCallback } from "react";

export function useSafeState(initialValue) {
  const isMounted = useRef(false);
  const [state, setState] = useState(initialValue);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const safeSetState = useCallback((value) => {
    if (isMounted.current) {
      setState(value);
    }
  }, []);

  return [state, safeSetState];
}
